<template>
  <v-container class="mt-8">
    <v-row>
      <v-col cols="12" md="6" lg="4" v-for="training in trainings" :key="training.id">
        <v-card class="lighten-5 mx-auto" max-width="600">
          <v-img
            class="white--text align-end"
            height="200px"
            :src="training.img"
          ></v-img>
          <v-card-title>{{ training.title }}</v-card-title>

          <v-card-subtitle class="pb-0">{{ training.dateString }}</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>{{ training.description }}</div>
          </v-card-text>

          <v-card-actions>
            <v-btn v-if="training.open" color="success title" text router :to="`/training/${training.id}`">Asssistir</v-btn>
            <v-btn v-else color="primary" text disabled>Em breve</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebaseApp from '@/firebase/init'

export default {
  name: 'MyTrainings',
  data () {
    return {
      trainings: []
    }
  },
  created () {
    const trainingsRef = firebaseApp.firestore().collection('trainings')
    const email = firebaseApp.auth().currentUser.email
    trainingsRef.where('participants', 'array-contains', email).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.trainings.push({ id: doc.id, ...doc.data() })
        })
      })
  }
}
</script>
